/**
 * Microsoft OAuth authentication hook
 * Provides Microsoft sign-in functionality using MSAL
 */

import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../utils/msalConfig';
import { API_URL } from '../utils/config';

export const useMicrosoftAuth = () => {
  const { instance } = useMsal();

  const signInWithMicrosoft = async () => {
    try {
      // Use popup authentication
      const response = await instance.loginPopup(loginRequest);
      
      // Send authentication data to backend
      const backendResponse = await fetch(`${API_URL}/auth/microsoft`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          access_token: response.accessToken,
          id_token: response.idToken,
          account: {
            homeAccountId: response.account.homeAccountId,
            environment: response.account.environment,
            tenantId: response.account.tenantId,
            username: response.account.username,
            name: response.account.name,
            localAccountId: response.account.localAccountId
          }
        }),
      });

      if (backendResponse.ok) {
        const data = await backendResponse.json();
        return data;
      } else {
        const errorData = await backendResponse.json().catch(() => ({}));
        throw new Error(errorData.error || 'Backend authentication failed');
      }
      
    } catch (error) {
      console.error('Microsoft sign-in failed:', error);
      
      // Handle specific MSAL errors
      if (error.name === 'BrowserAuthError') {
        throw new Error('Microsoft authentication was cancelled or failed');
      } else if (error.name === 'InteractionRequiredAuthError') {
        throw new Error('Additional interaction required for Microsoft authentication');
      } else {
        throw error;
      }
    }
  };

  const signOutMicrosoft = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: window.location.origin,
        mainWindowRedirectUri: window.location.origin
      });
    } catch (error) {
      console.error('Microsoft sign-out failed:', error);
    }
  };

  return { 
    signInWithMicrosoft,
    signOutMicrosoft
  };
};